import bignumber from '@/utils/bignumber'
import { TOKENS_INFO, ERC20_ABI } from '@/constants'

// Initial web3.js
let web3 = {}
let web3ForRead = {}
if (process.env.NODE_ENV !== 'test') {
  const Web3 = require('web3')
  const httpProvider = new Web3.providers.HttpProvider(process.env.ETH_NODE_URL)
  web3ForRead = new Web3(httpProvider)
  // Modern dapp browsers...
  if (typeof window.ethereum !== 'undefined') {
    web3 = new Web3(window.ethereum)

  // Legacy dapp browsers...
  } else if (typeof window.web3 !== 'undefined') {
    web3 = new Web3(window.web3.currentProvider)
  } else {
    web3 = new Web3(httpProvider)
  }
}

export default class EthereumService {
  constructor () {
    this.web3 = web3
    this.web3ForRead = web3ForRead
  }

  getWallets () {
    return this.web3.eth.getAccounts()
  }

  getCurrentProvider () {
    if (this.web3.currentProvider.isMetaMask) return 'metamask'
    else if (this.web3.currentProvider.isTrust) return 'trust'
    else if (typeof window.SOFA !== 'undefined') return 'coinbase-wallet'
    else if (typeof window.__CIPHER__ !== 'undefined') return 'cipher'
    else if (this.web3.currentProvider.constructor.name === 'EthereumProvider') return 'mist'
    else if (this.web3.currentProvider.constructor.name === 'Web3FrameProvider') return 'parity'
    else if (this.web3.currentProvider.constructor.name === 'WalletConnectProvider') return 'wallet-connect'
    else if (this.web3.currentProvider.host && this.web3.currentProvider.host.indexOf('infura') !== -1) return 'infura'
    else if (this.web3.currentProvider.host && this.web3.currentProvider.host.indexOf('localhost') !== -1) return 'localhost'
    else return 'unknown'
  }

  async getTokenBalance (userAddress, tokenAddress, decimal) {
    const newUserAddress = (userAddress).substring(2)
    const contractData = '0x70a08231000000000000000000000000' + newUserAddress
    const amount = await this.web3.eth.call({ to: tokenAddress, data: contractData })
    return bignumber(amount).toBase(decimal)
  }

  async getEthBalance (userAddress) {
    const balance = await this.web3.eth.getBalance(userAddress)
    return bignumber(balance).toBase()
  }

  async getCurrentNetworkConnected () {
    if (process.env.ENV === 'alpha') {
      return 'main'
    }
    const network = await this.web3.eth.net.getNetworkType()
    return network
  }

  async getTokensInfo () {
    const network = await this.getCurrentNetworkConnected()
    return TOKENS_INFO[network]
  }

  async getTokenContract (tokenAddress) {
    const contract = await new this.web3.eth.Contract(ERC20_ABI, tokenAddress)
    return contract
  }

  async getBlockDetail (blockNumber) {
    const data = await this.web3.eth.getBlock(blockNumber)
    return data
  }

  async getTransactionReceipt (txHash) {
    const tx = await this.web3.eth.getTransactionReceipt(txHash)
    return tx
  }

  async getTransaction (hash) {
    const tx = await this.web3.eth.getTransaction(hash)
    return tx
  }

  async getLatestBlockNumber () {
    const blockNumber = await web3.eth.getBlockNumber()
    return blockNumber
  }
}



// WEBPACK FOOTER //
// ./src/services/ethereum/index.js